import { SearchWindowType } from "src/scripts/typings/WindowType";

// Tested
export function updateGtagConsentFromPreferences(windowScope: SearchWindowType, performance: boolean, personalisation: boolean) {
	windowScope.gtag ??= function (...args) {
		windowScope.dataLayer = windowScope?.dataLayer || [];
		windowScope.dataLayer.push(args);
	};
	windowScope.gtag("event", "consent_updated", {});
	if (performance && personalisation) {
		windowScope.gtag("event", "consent_granted", {});
	} else if (performance) {
		windowScope.gtag("event", "performance_consent_granted", {});
	} else if (personalisation) {
		windowScope.gtag("event", "personalisation_consent_granted", {});
	} else {
		windowScope.gtag("event", "consent_denied", {
			count: 1
		});
	}
}

// Tested
export function updateGtagConsentToAllowAll(windowScope: SearchWindowType) {
	updateGtagConsentFromPreferences(windowScope, true, true);
}
